<template>
    <div class="checkout--page__payment__block">

        <div class="checkout--page__payment__methods">
            <ul class="list-unstyled" v-for="(gateway,index) in gateways" v-if="gateways.length == 1">
              <h4>{{ gateway.name }}</h4>
            </ul>

            <ul class="list-unstyled" v-for="(gateway,index) in gateways" v-if="gateways.length > 1">
                <li data-toggle="tooltip" data-placement="left" :title="gateway.description">
                    <input type="radio" name="gateway_type" v-model="gateway_selected" v-bind:value="gateway.type" :id="gateway.type+index"  @change="update_gateway_selection"/>
                    <label :for="gateway.type+index">{{ gateway.name }}</label>
                </li>
            </ul>
        </div>

        <div class="row">
            <div class="col-md-12 col-sm-12 col-xs-12">

                <div class="checkout-error" v-show="error_code">
                    <p>{{ error_code }}</p>
                </div>


                <div v-if="total !== 0 || total_partial !== 0">

                    <div v-show="active_module.settings.payment.partial == 'x'" class="credit-payment">
                        <input type="checkbox" :id="active_gateway.type+'partial'" @change="update_partial"/>
                        <label :for="active_gateway.type+'partial'">{{ $t('payment_list.title_partial') }}</label>
                    </div>

                    <div v-show="active_gateway.allow_installments === 'x'" class="credit-options">
                        <label :for="active_gateway.type+'installment'">Taksit:</label>
                        <select v-model="selected_installment.installment" @change="update_installment">
                          <template v-for="(multiplier, index) in active_gateway.installments">
                            <option v-bind:value="index" v-if="multiplier !== ''">{{ formatInstallmentAmount (multiplier, index) }}</option>
                          </template>
                        </select>
                    </div>
                </div>


                <div class="alert alert-info" role="alert" v-if="total === 0 && total_partial === 0">
                    <p>{{ $t('payment_list.info_emptycart') }}</p>
                </div>

                <div class="checkout--page__payment__buttons" v-if="total !== 0 || total_partial !== 0">
                    <button class="btn btn-default btn-block" :disabled="!gateway_selected" @click="pay">{{ $t('payment_list.title_paysecurely') }}</button>
                </div>

                <payments-accepted></payments-accepted>

                <p class="text-center payment--guarantee"><img class="icon icons8-Lock" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAABn0lEQVRIS+WVS04bQRCGvxrG4SEi2xukREJ4lV0UEAegZy4QOEHICQAJ1pA1kRKfAOcEgQtMNweIYrFk5QghJDYYEREeQxcaKQubh8cyskWUf9ld3V/VX6VuYQCSATDoCmKMKQVBsKSqRkSMqjoRcd77qnOumZdoLsQYMy0i30WkcvcyVW2o6oJzrt4JlAuJoqguIu+AX8CG974RBEEG3ACmVLVurZ3pGRLH8SKwBZx67yut1vy1sAEUgY9JktQeA3WsJIqimoh8AD4lSZJl3qY4jrO1dVX9Zq3NEnpQeZCswXNdQHatteb5Qa42WZaA4o/j8vTvNCy9GrtovCmdZf63ab/5snJ0PlIZD9Pm7MRJXZXmi1Wqd+Pu2XX9ma/AUt7sd9ivFlZZbt2/D9nEIWR96E3KbmGNtv78p5DLFM4uoTwKQ8Ejbj7Vrr1DuLqB4RDevu4T5OcB3CgMCcxM9glycg6nf6A4CuWxPkG6mumn9uSfg2wjvO8q64eClJ3CGvMdnxX9QilNqfUEUnbCkEVZoe3fz/1+e66o5eBAILfaRMgakmXbuwAAAABJRU5ErkJggg==" width="25" height="25">{{ $t('payment_list.title_securepayment') }}</p>
            </div>
        </div>
        <modal v-if="license_expired" @close="license_expired = null">
        {{ $t('license.expired')}}
        <br>
        <button class="btn btn-primary" @click="license_expired = null">{{ $t('license.close_button')}}</button>
        </modal>
    </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import PaymentsAccepted from './_partials/payments-accepted.vue';
  // import _ from 'lodash';

  export default {
    data () {
      return {
        gateway_selected: '',
        license_expired: null,
      };
    },

    components: {
      PaymentsAccepted
    },

    computed: {
      ...mapGetters([
        'active_module',
        'selected_installment',
      ]),
    },
    methods: {
      ...mapActions([
        'select_payment_method',
        'select_installment',
        'select_partial',
        'make_payment',
      ]),

      formatInstallmentAmount (multiplier, index) {
        let total = this.selected_partial ? this.total_partial : this.total;

        multiplier = multiplier >= 1 ? multiplier : 1;

        let part = +(Math.round(((total * multiplier) / index) + 'e+2') + 'e-2');
        let totalPart = +(Math.round((total * multiplier) + 'e+2') + 'e-2');

        return `${index} x ${part} ${this.currency} = ${totalPart} ${this.currency}`;
      },

      pay () {
        this.make_payment().catch((resp) => {
          if (resp.message === 'License expired.') {
            this.license_expired = true;
          }
        });
      },

      update_gateway_selection (e) {
        this.select_payment_method({ gateway_type: e.target.value });
      },
      update_installment (e) {
        this.select_installment({ installment: e.target.value });
      },
      update_partial (e) {
        this.select_partial(e.target.value);
      },

      set_gateway (gateways) {
        if (gateways.length === 1) {
          let gateway = gateways[0].type;

          this.gateway_selected = gateway;
          this.select_payment_method({ gateway_type: gateway });
        }
      }
    },
    props: [
      'currency',
      'gateways',
      'active_gateway',
      'error_code',
      'total',
      'total_partial',
      'selected_partial'
    ],

    mounted () {
      if (this.gateways) {
        this.set_gateway(this.gateways);
      }
    },

    watch: {
      'gateways': function (val) {
        this.set_gateway(val);
      }
    }
  };

</script>

<style scoped>

  .checkout--page__payment__block {
    margin-top: 5%;
    padding: 5%;
    border: 1px solid #ddd; }
  .checkout--page__payment__block p{
      margin: 0;
  }
  .checkout--page__payment__block .payment__providers {
    display: -ms-flexbox;
    display: flex;
    flex-wrap: wrap;
    -ms-flex-pack: center;
        justify-content: center;
    -ms-flex-align: center;
        align-items: center;
    margin-top: 5%; }
    .checkout--page__payment__block .payment__providers li {
      margin-bottom: 5px; }
  .checkout--page__payment__block .checkout--page__payment__buttons {
    display: -ms-flexbox;
    display: flex; }
    .checkout--page__payment__block .checkout--page__payment__buttons .btn {
      /*width: 50%;*/
      background: linear-gradient(to bottom, #f7dfa5, #f0c14b);
      font-weight: 400;
      font-size: 20px;
      height: 60px;
      color: #000; }
  .checkout--page__payment__block .payment--guarantee {
    /*border: 1px solid #ddd;*/
    padding: 3%;
     }
     .checkout--page__payment__block .payment--guarantee img{
     margin-right:4px;
     margin-top:-6px;
     }
  .checkout--page__payment__block .checkout--page__payment__methods li {
    font-size: 16px;
    margin-bottom: 15px;
         display: flex;
     }
    .checkout--page__payment__block .checkout--page__payment__methods li p {
      margin-left: 18px; }
    .checkout--page__payment__block .checkout--page__payment__methods ul input {
      margin-right: 6px; }
  .checkout--page__payment__block .checkout--page__credit__card--info .reset-col-padding .col-lg-2, .checkout--page__payment__block .checkout--page__credit__card--info .reset-col-padding .col-md-2, .checkout--page__payment__block .checkout--page__credit__card--info .reset-col-padding .col-xs-2, .checkout--page__payment__block .checkout--page__credit__card--info .reset-col-padding col-sm-2 {
    padding-right: 10px;
    padding-left: 10px; }
  .checkout--page__payment__block .checkout--page__credit__card--info .checkout--page__card__cvv--block {
    display: -ms-flexbox;
    display: flex; }
    .checkout--page__payment__block .checkout--page__credit__card--info .checkout--page__card__cvv--block img {
      margin-top: -10px; }
  .checkout--page__payment__block .checkout--page__credit__card--info .checkout--page__card__installements {
    display: -ms-flexbox;
    display: flex;
    -ms-flex-pack: justify;
        justify-content: space-between;
    margin-bottom: 0px; }
  .checkout--page__payment__block .checkout--page__credit__card--info .help-block {
    margin-bottom: 0px; }
  .checkout--page__payment__block .checkout--page__credit__card--info #card--month {
    width: 100%;
    height: 25px; }
  .checkout--page__payment__block .checkout--page__credit__card--info #card--year {
    height: 25px; }
  .checkout--page__payment__block .checkout--page__credit__card--info .cvv--cart--example {
    margin-top: 10px; }
  .checkout--page__payment__block .checkout--page__credit__card--info .card-number-heading {
    padding-left: 15px; }
  .checkout--page__payment__block .checkout--page__credit__card--info .checkout--page__card__numbers {
    width: 50px;
    text-align: center;
    height: 34px;
    margin-right: 5px;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
    transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s; }
  .checkout--page__payment__block .checkout--page__credit__card--info .checkout--page__cvv--input {
    width: 50px;
    text-align: center;
    height: 28px;
    margin-right: 5px;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
    transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s; }
  .checkout--page__payment__block .checkout--page__credit__card--info .checkout--page__credit__card--total--mobile,
  .checkout--page__payment__block .checkout--page__credit__card--info .checkout--page__card__name__mobile,
  .checkout--page__payment__block .checkout--page__credit__card--info .checkout--page__card__pay__btn__mobile,
  .checkout--page__payment__block .checkout--page__credit__card--info .checkout--page__card__numbers--mobile {
    display: none; }
  .checkout--page__payment__block .checkout--page__credit__card--info .checkout--page__card__info--name {
    margin-top: 2%; }
    .checkout--page__payment__block .checkout--page__credit__card--info .checkout--page__card__info--name h5 {
      margin-top: 5px; }
  .checkout--page__payment__block .checkout--page__credit__card--info .payment--btn {
    background: linear-gradient(to bottom, #f7dfa5, #f0c14b);
    color: #000;
    font-weight: 400;
    margin-top: 30px; }
  .checkout--page__payment__block .checkout--page__credit__card--info .cancel--payment--btn {
    background: linear-gradient(to bottom, #F74F4B, #E43137);
    color: #ffffff; }
  .checkout--page__payment__block .checkout--page__credit__card--info .checkout--page__card__dates {
    display: -ms-flexbox;
    display: flex;
    -ms-flex-align: start;
        align-items: flex-start;
    font-size: 12px;
    margin-top: 3%; }
  .checkout--page__payment__block .checkout--page__credit__card--info .form-control {
    text-align: center; }
  .checkout--page__payment__block .checkout--page__credit__card--total {
    margin-top: -20px; }
    .checkout--page__payment__block .checkout--page__credit__card--total p {
      font-size: 26px; }
      .checkout-error{
      border: 2px solid red;
      padding: 10px;
      font-weight: 700;
      margin-bottom: 5%;
      }
      .checkout-error p{
      margin-bottom: 0;
      }
  .credit-payment, .credit-options{
      margin: 15px 0 25px 0;
      border: 1px solid #ddd;
      padding: 10px 10px 10px 10px;
      display: flex;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
  }
  .credit-options{
      flex-direction:column;
  }
  .credit-payment input, .credit-options label{
      margin-right: 5px;

  }
  .credit-payment label{
      color: #337ab7;
      margin-bottom: 0;
  }
  .credit-options select{
      padding: 2px;
      width: 100%;
  }
  @media (min-width: 768px) {
    .modal-dialog {
      width: 400px;
      margin: 30px auto; } }

  @media (max-width: 767px) {
      body{
          /* padding-bottom: 10px; */
      }
      .checkout--page__payment__block {
          font-size: 16px;
      }
      .checkout--page__payment__block .payment--guarantee {
      padding: 0;
       }
    .checkout--page__cart {
      margin-top: 6%; }
    .checkout--page__card__number {
      display: -ms-flexbox;
      display: flex; }
    .checkout--page__payment__block .checkout--page__credit__card--total {
      margin-top: 10px; } }

  @media screen and (max-width: 500px) {
    .checkout--page__payment__block .payment__providers {
      margin-top: 30px; }
    .checkout--page__payment__block .checkout--page__credit__card--info .checkout--page__card__info--name {
      display: none; }
    .checkout--page__payment__block .checkout--page__credit__card--info .checkout--page__credit__card--total--mobile,
    .checkout--page__payment__block .checkout--page__credit__card--info .checkout--page__card__name__mobile,
    .checkout--page__payment__block .checkout--page__credit__card--info .checkout--page__card__pay__btn__mobile {
      display: block;
      margin-top: 5%; }
    .checkout--page__payment__block .checkout--page__credit__card--info .checkout--page__credit__card--total--mobile strong {
      font-size: 18px; }
    .checkout--page__payment__block .checkout--page__credit__card--info .checkout--page__credit__card--total {
      display: none; }
    .checkout--page__payment__block .checkout--page__credit__card--info .payment--btn {
      margin-top: 0px; }
    .checkout--page__payment__block .checkout--page__payment__buttons .btn {
      width: 100%; }
    .checkout--page__payment__block .checkout--page__payment__methods ul input{
      width: 25px;
          }
    .checkout--page__payment__block .checkout--page__payment__methods ul:last-child input{
          width: 20px;
         }
    .checkout--page__payment__block .checkout--page__payment__methods ul:first-child input{
          width: 20px;
         }
     }

  @media screen and (max-width: 400px) {
    .checkout--page__payment__block .checkout--page__credit__card--info .reset-col-padding {
      display: none; }
    .checkout--page__payment__block .checkout--page__credit__card--info .checkout--page__card__numbers--mobile {
      display: block; }
    .checkout--page__payment__block .checkout--page__credit__card--info .payment--btn {
      margin-top: 5px; }
    .checkout--page__cart .checkout--page__discount {
      -ms-flex-pack: center;
          justify-content: center; }
    .credit-payment select{
      width: 100%; } }

</style>



// WEBPACK FOOTER //
// PaymentList.vue?65349994